import { call, put, select } from 'redux-saga/effects';
import { urls } from '../../../common/urls';
import { getHttp, getHttpwithtoken, postHttpwithtoken } from '../../../common/ApiCall';
import {
  searchPlacesFailure,
  searchPlacesLoading,
  searchPlacesSuccess,
  addressFromLatLongFailure,
  addressFromLatLongLoading,
  addressFromLatLongSuccess,
} from '../../ducks/LocationSlice';

// Search Places Handler
export function* handlerGetSearchPlace(action: any): Generator<any, void, any> {
  try {
    yield put(searchPlacesLoading());
    const response: any = yield call(getHttpwithtoken, `${urls.baseURL}${urls.serchplace}?query=${action.payload}`);
    
    if (response.success) {
      yield put(searchPlacesSuccess(response.data));
    } else {
      yield put(searchPlacesFailure(response.message || 'Failed to search places'));
    }
  } catch (error: any) {
    yield put(searchPlacesFailure(error.message || 'Failed to search places'));
  }
}

// Address from Lat Long Handler
export function* handlerAddressFromLatLong(action: any): Generator<any, void, any> {
  try {
    yield put(addressFromLatLongLoading());
    const response: any = yield call(getHttpwithtoken, `${urls.baseURL}${urls.getaddressfromlatlng}?lat=${action.payload.lat}&lng=${action.payload.lng}`);
    
    if (response.success) {
      yield put(addressFromLatLongSuccess(response.data));
    } else {
      yield put(addressFromLatLongFailure(response.message || 'Failed to get address'));
    }
  } catch (error: any) {
    yield put(addressFromLatLongFailure(error.message || 'Failed to get address'));
  }
}
